<div
  [ngClass]="[card_wrap ? 'card shadow-sm' : '']"
  [tds-data-loader]="{
    key: 'person-assignment',
    size: 'lg',
    as_overlay: true
  }"
>
  <div [ngClass]="{ 'card-body': card_wrap }">
    <h4 class="mb-3" [ngClass]="{ 'card-title': card_wrap }">
      {{ 'person_assignment' | translate }}
    </h4>

    @if (!is_review_or_summary) {
      <form>
        <div class="mb-3">
          <label for="current_user" class="form-label">{{ 'existing_person' | translate }}</label>
          <input
            id="current_user"
            class="form-control"
            type="text"
            disabled="true"
            [attr.value]="getCurrentUserLabel()"
          />
        </div>
        <div class="form-group mb-3">
          <tds-type-ahead
            id="user-search"
            placeholder="{{ 'search_detailed_placeholder' | translate }}"
            label="{{ 'replacement_person' | translate }}"
            [control]="user_control"
            [typeahead]="search"
            [loading]="loading"
            [result_template]="user_control.value ? userTemplate : null"
            [result_format]="input_format"
            [input_format]="input_format"
            [input_required_translation]="
              'input_is_required' | translate: ('replacement_person' | translate)
            "
            [no_results_found_translation]="'no_results_found' | translate"
            [loading_translation]="'loading' | translate"
            (selectItem)="selectUser($event)"
          />
          @if (user_not_found) {
            <div class="d-flex mt-2">
              <small class="form-text text-muted pe-2">{{ 'person_not_found' | translate }}</small>
            </div>
          }
        </div>
      </form>
    }

    @if (is_review_or_summary && asset_details) {
      <div class="row row-cols-1 row-cols-sm-2">
        <div class="col d-flex flex-column gap-1">
          <h6 class="mb-0">{{ 'existing_person' | translate }}</h6>
          @if (existing_user.name) {
            <span>{{ existing_user.name }}</span>
          }
          @if (existing_user?.email) {
            <span>{{ existing_user.email }}</span>
          }
        </div>
        <div class="col d-flex flex-column gap-1 mt-3 mt-sm-0">
          <h6 class="mb-0">{{ 'replacement_person' | translate }}</h6>
          @if (replacement_user.name) {
            <span>{{ replacement_user.name }}</span>
          }
          @if (replacement_user?.email) {
            <span>{{ replacement_user.email }}</span>
          }
        </div>
      </div>
    }
  </div>
</div>

<ng-template #userTemplate>
  <ts-person-card [person]="user_control.value" (clear)="selectUser()" />
</ng-template>
